/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { productsService } from '../../../_services/products.service'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import ProductInput from './ProductInput'
import Item0 from './Item0'
import Item5 from './Item5'
import Item1 from './Item1'
import Item2 from './Item2'
import Item3 from './Item3'
import Item4 from './Item4'
import Item6 from './Item6'
import UploadImages from './UploadImages'
import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

const indexes = [
  { label: 'کالای نهایی (انبار محصولات)', index: 99 },
  { label: 'کالای درجه دو (انبار محصولات)', index: 0 },
  { label: 'ورق پرس شده (انبار نیمه ساخته)', index: 1 },
  { label: 'تایل برش شده (انبار نیمه ساخته)', index: 2 },
  { label: 'کارتن (انبار نیمه ساخته)', index: 3 },
  { label: 'کارتن درجه 2 (انبار نیمه ساخته)', index: 4 },
  { label: 'کالای درجه سه (انبار محصولات)', index: 5 },
  { label: 'کارتن درجه 3 (انبار نیمه ساخته)', index: 6 }
]

const initialData = {
  name: 'پارکت ',
  categoryId: '',
  brandId: '',
  extraCode: '',
  shortExtraCode: '',
  conversionUnit: undefined,
  measurementType: 0,
  subMeasurementType: 1,
  numberOfParts: undefined,
  warehouseUnitTypes: [8, 9],
  categoryClass: 0,

  items: [
    {
      index: 0,
      unitType: 7,
      warehouseUnitType: 8,
      relatedProductType: 1,
      measurementType: 0,
      subMeasurementType: 1,

      name: 'پارکت درجه دو ',
      categoryId: '',
      brandId: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: false,
      warehouseUnitTypes: [8, 9],
      categoryClass: 1
    },
    {
      index: 1,
      unitType: 4,
      warehouseUnitType: 5,
      relatedProductType: 1,
      measurementType: 0,
      subMeasurementType: 2,
      categoryId: '00000000-0000-0000-0000-000000000000',

      name: 'ورق پرس شده ',
      brandId: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: 2.9768,
      numberOfParts: undefined,
      selectFromList: false,
      warehouseUnitTypes: [5, 9],
      categoryType: 1,
      categoryHelperType: 1,
      categoryClass: 0
    },
    {
      index: 2,
      unitType: 6,
      warehouseUnitType: 5,
      relatedProductType: 1,
      measurementType: 5,
      categoryId: '00000000-0000-0000-0000-000000000000',

      name: 'تایل برش شده ',
      brandId: '',
      extraCode: '',
      shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: false,
      warehouseUnitTypes: [5, 9],
      categoryType: 1,
      categoryHelperType: 3,
      categoryClass: 0
    },
    {
      index: 3,
      unitType: 7,
      warehouseUnitType: 5,
      relatedProductType: 0,
      measurementType: 9,
      categoryId: '00000000-0000-0000-0000-000000000000',

      // relatedProductId: '00000000-0000-0000-0000-000000000000',
      name: '',
      brandId: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: true,
      warehouseUnitTypes: [5, 9],
      categoryType: 1,
      categoryHelperType: 2,
      categoryClass: 0
    },
    {
      index: 4,
      unitType: 7,
      warehouseUnitType: 5,
      relatedProductType: 0,
      measurementType: 9,
      categoryId: '00000000-0000-0000-0000-000000000000',
      brandId: '00000000-0000-0000-0000-000000000000',

      // relatedProductId: '00000000-0000-0000-0000-000000000000',
      // relatedProductId: '6602e6f5-ea46-4562-a74b-94f4c0cd8cd0',
      name: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: true,
      warehouseUnitTypes: [5, 9],
      categoryType: 1,
      categoryHelperType: 2,
      categoryClass: 1
    },
    {
      index: 5,
      unitType: 7,
      warehouseUnitType: 8,
      relatedProductType: 1,
      measurementType: 5,

      name: 'پارکت درجه سه ',
      categoryId: '',
      brandId: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: false,
      warehouseUnitTypes: [8, 9],
      categoryClass: 2
    },
    {
      index: 6,
      unitType: 7,
      warehouseUnitType: 5,
      relatedProductType: 0,
      measurementType: 9,
      categoryId: '00000000-0000-0000-0000-000000000000',
      brandId: '00000000-0000-0000-0000-000000000000',

      // relatedProductId: '00000000-0000-0000-0000-000000000000',
      // relatedProductId: 'ec9efb33-1003-4f24-bb5b-d77d6be8d601',
      name: '',
      extraCode: '',
      // shortExtraCode: '',
      conversionUnit: undefined,
      numberOfParts: undefined,
      selectFromList: true,
      warehouseUnitTypes: [5, 9],
      categoryType: 1,
      categoryHelperType: 2,
      categoryClass: 2
    }
  ]
}

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      finishLoading: false,
      notFinishLoading: false,
      key: 'info',
      id: this.props.match.params.id,
      isGradeTwo: false,
      data: initialData
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.props.match.params

    if (id) {
      this.setState({ loading: true })

      await productsService
        .getById(id)
        .then(res => {
          // console.log(res.data)

          // data = res.data;
          // if (!data.relatedProducts || data.relatedProducts.length === 0) {
          //   data["relatedProducts"] = initialRelatedProducts;
          // }

          // if (data.categoryId === "2f04bd46-c365-4320-3bcf-08d7cb2bcfeb" || data.categoryId === "c8374e6c-8809-46b6-d2b6-08d7cb2e9469") {
          //   var rp = data.relatedProducts;
          //   rp = rp.filter(el => el.index !== 4);
          //   data["relatedProducts"] = rp;
          //   this.setState({ isGradeTwo: true })
          // }

          // for (let index = 0; index < 5; index++) {
          //   if (!data.relatedProducts[index]) {
          //     data.relatedProducts[index]["relatedProductId"] = "";
          //   }

          // }

          let data = { ...res.data }

          let items = [...data.relatedProducts]

          items.forEach(item => {
            item['relatedId'] = item.id
            // item['id'] = item.id
            // item['index'] = item.index
            // item['relatedProductId'] = item.relatedProductId
            item['name'] = item.relatedProduct.name
            item['brandId'] = item.relatedProduct.brandId
            item['categoryId'] = item.relatedProduct.categoryId
            item['categoryType'] = item.relatedProduct.category.categoryType
            item['measurementType'] = item.relatedProduct.measurementType
            item['subMeasurementType'] = item.relatedProduct.subMeasurementType
            item['conversionUnit'] = item.relatedProduct.conversionUnit
            item['extraCode'] = item.relatedProduct.extraCode
            item['shortExtraCode'] = item.relatedProduct.shortExtraCode
            item['numberOfParts'] = item.relatedProduct.numberOfParts
            item['selectFromList'] = true

            item['relatedProduct'] = undefined
          })

          data['items'] = items
          data['relatedProducts'] = undefined

          console.log(data)
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          // console.log(error);

          this.setState({ loading: false })
        })
    } else {
      this.setState({ data: initialData })
    }
  }

  handleSubmit = (values, setSubmitting, resetForm) => {
    // if (this.state.saveAndNew) {
    //   this.setState({ loading: true, submittingAndNew: true, submittingAndGoBack: false })
    // } else {
    //   this.setState({ loading: true, submittingAndNew: false, submittingAndGoBack: true })
    // }
    this.setState({ loading: true })

    console.log(values)
    console.log(JSON.stringify(values))

    if (values.id) {
      productsService
        .EditProductAndRelatedProducts(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ویرایش کالا',
            'کالا "' + values.name + '" با موفقیت ویرایش شد'
          )
          history.push('/admin/products')
          setSubmitting(false)
          this.setState({
            loading: false,
            submittingAndNew: false,
            submittingAndGoBack: false
          })
        })
        .catch(error => {
          console.log(error.response.data.index)

          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.index != undefined
          ) {
            let msg = ''

            if (error.response.data.index === 99) {
              msg = `قبلا کالایی با کد [${values.extraCode}] و ضریب تبدیل [${
                values.conversionUnit
              }] برای [${
                indexes.find(e => e.index === error.response.data.index)?.label
              }] ایجاد شده است`
            } else if (
              indexes.find(e => e.index === error.response.data.index) &&
              values.items.find(e => e.index === error.response.data.index)
            ) {
              msg = `قبلا کالایی با کد [${
                values.items.find(e => e.index === error.response.data.index)
                  ?.extraCode
              }] برای [${
                indexes.find(e => e.index === error.response.data.index)?.label
              }] ایجاد شده است`
            } else {
              msg = 'مشکلی پیش آمد لطفا بعدا دوباره سعی کنید'
            }

            toastr.warning(msg)
          }

          setSubmitting(false)
          this.setState({
            loading: false,
            submittingAndNew: false,
            submittingAndGoBack: false
          })
        })
    } else {
      productsService
        .AddProductAndRelatedProducts(JSON.stringify(values))
        .then(res => {
          console.log(res.data)

          this.setState({
            loading: false,
            submittingAndNew: false,
            submittingAndGoBack: false
          })
          toastr.success(
            'ثبت کالا جدید',
            'کالا جدید  "' + values.name + '" با موفقیت ثبت شد'
          )

          setSubmitting(false)

          if (this.state.saveAndNew) {
            // history.push('/admin/products/new/');

            resetForm(initialData)
          } else {
            history.push('/admin/products/')
          }

          // this.props.onClose()
        })
        .catch(error => {
          console.log(error.response.data.index)

          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.index != undefined
          ) {
            let msg = ''

            if (error.response.data.index === 99) {
              msg = `قبلا کالایی با کد [${values.extraCode}] و ضریب تبدیل [${
                values.conversionUnit
              }] برای [${
                indexes.find(e => e.index === error.response.data.index)?.label
              }] ایجاد شده است`
            } else if (
              indexes.find(e => e.index === error.response.data.index) &&
              values.items.find(e => e.index === error.response.data.index)
            ) {
              msg = `قبلا کالایی با کد [${
                values.items.find(e => e.index === error.response.data.index)
                  ?.extraCode
              }] برای [${
                indexes.find(e => e.index === error.response.data.index)?.label
              }] ایجاد شده است`
            } else {
              msg = 'مشکلی پیش آمد لطفا بعدا دوباره سعی کنید'
            }

            toastr.warning(msg)
          }

          setSubmitting(false)
          this.setState({
            loading: false,
            submittingAndNew: false,
            submittingAndGoBack: false
          })
        })
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  // validateForm = (errors) => {
  //   if (Object.keys(errors).length > 0) {
  //     // // console.log(errors)
  //     let obj = errors
  //     let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
  //       driverDocuments,
  //       user
  //     } = obj;
  //     if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
  //       this.setState({ key: "info" })
  //     } else if (driverDocuments) {
  //       this.setState({ key: "images" })
  //     }
  //   }
  // }

  render() {
    const { data, submittingAndNew, submittingAndGoBack, loading } = this.state
    const { categoryType } = this.props

    const isGradeTwoItem = Yup.object().test(
      'Related Product',
      'محصول مرتبط',
      function(value) {
        // console.log(value);

        var res = false

        if (value.index < 4 && value.relatedProductId !== undefined) {
          res = true
        }

        return res
      }
    )

    const item = Yup.object().shape({
      relatedProductId: Yup.string().when('selectFromList', {
        is: true,
        then: Yup.string().required('انتخاب کالا')
        // .positive('انتخاب کالا')
      }),

      name: Yup.string().when('selectFromList', {
        is: false,
        then: Yup.string()
          .trim()
          .required('نام کالا')
      }),

      categoryId: Yup.string().when('selectFromList', {
        is: false,
        then: Yup.string()
          .trim()
          .required('دسته بندی')
      }),

      brandId: Yup.string().when('selectFromList', {
        is: false,
        then: Yup.string()
          .trim()
          .required('برند')
      }),

      extraCode: Yup.string().when('selectFromList', {
        is: false,
        then: Yup.string()
          .trim()
          .required('کد کالا')
      }),

      measurementType: Yup.string().when('selectFromList', {
        is: false,
        then: Yup.string()
          .trim()
          .required('واحد اصلی')
      })

      // name: Yup.string().trim().required('نام کالا'),
      // categoryId: Yup.string().trim().required('دسته بندی'),
      // brandId: Yup.string().trim().required('برند'),
      // extraCode: Yup.string().trim().required('کد کالا'),
      // measurementType: Yup.string().trim().required('واحد اصلی'),

      // subMeasurementType: Yup.string().trim().required('واحی فرعی'),
      // conversionUnit: Yup.string().trim().required('ضریب تبدیل'),
      // numberOfParts: Yup.string().trim().required('تعداد تایل'),
    })

    const ValidationSchema = Yup.object().shape({
      name: Yup.string()
        .trim()
        .required('نام کالا'),
      categoryId: Yup.string()
        .trim()
        .required('دسته بندی'),
      brandId: Yup.string()
        .trim()
        .required('برند'),
      extraCode: Yup.string()
        .trim()
        .required('کد کالا'),
      shortExtraCode: Yup.string()
        .trim()
        .required('کد کوتاه کالا'),
      measurementType: Yup.string()
        .trim()
        .required('واحد اصلی'),
      subMeasurementType: Yup.string()
        .trim()
        .required('واحی فرعی'),
      conversionUnit: Yup.string()
        .trim()
        .required('ضریب تبدیل'),
      // numberOfParts: Yup.string().trim().required('تعداد تایل'),
      // // quantity: Yup.string().trim().required('موجودی'),
      items: Yup.array()
        .of(item)
        .required('تمامی اطلاعات محصول')
      // relatedProducts: categoryType === 2
      //   ? isGradeTwo
      //     ? Yup.array().of(isGradeTwoItem)
      //     : Yup.array().of(item).min(5, 'تمامی اطلاعات').required('تمامی اطلاعات محصول')
      //   : '',

      // relatedProductId: categoryType > 0 && Yup.string().trim().required(categoryType === 2 ? 'ورق پرس شده مرتبط' : 'کالای مرتبط'),

      // description: Yup.string().trim().required('توضیحات'),
    })
    return (
      <div className="row">
        <div className="col-lg-10 col-lg-offset-1 col-md-12 col-sm-12 col-xs-12">
          <Formik
            enableReinitialize
            initialValues={data}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(true)
              this.handleSubmit(values, setSubmitting, resetForm)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                validateForm
              } = props
              return (
                <form onSubmit={handleSubmit}>
                  {/* <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}
                      onClick={() =>
                        validateForm().then(errors => {
                          console.log(errors);
                        })}
                    >
                      {isSubmitting ?
                        <AiOutlineLoading className="mdi-spin" size="22px" />
                        :
                        <AiOutlineSave size="22px" />

                      }
                    ذخیره
                  </button> */}
                  {/* <Tabs transition={false}
                        id="controlled-tab-example"
                        activeKey={this.state.key}
                        onSelect={key => this.setState({ key })}
                      >

                        <Tab eventKey="info" title="اطلاعات کالا"> */}

                  <ProductInput
                    {...props}
                    categoryType={2}
                    initialData={initialData}
                  />
                  <Item0
                    {...props}
                    categoryType={2}
                    // index={0}
                    index={values.items.findIndex(el => el.index === 0)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 0)
                    // }
                  />
                  <Item5
                    {...props}
                    categoryType={2}
                    // index={5}
                    index={values.items.findIndex(el => el.index === 5)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 5)
                    // }
                  />
                  <Item1
                    {...props}
                    categoryType={1}
                    // index={1}
                    index={values.items.findIndex(el => el.index === 1)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 1)
                    // }
                  />
                  <Item2
                    {...props}
                    categoryType={1}
                    // index={2}
                    index={values.items.findIndex(el => el.index === 2)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 2)
                    // }
                  />
                  <Item3
                    {...props}
                    categoryType={1}
                    // index={3}
                    index={values.items.findIndex(el => el.index === 3)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 3)
                    // }
                    initialData={initialData}
                  />
                  <Item4
                    {...props}
                    categoryType={1}
                    // index={4}
                    index={values.items.findIndex(el => el.index === 4)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 4)
                    // }
                    initialData={initialData}
                  />
                  <Item6
                    {...props}
                    categoryType={1}
                    // index={6}
                    index={values.items.findIndex(el => el.index === 6)}
                    // data={
                    //   values.items && values.items.find(el => el.index === 6)
                    // }
                    initialData={initialData}
                  />

                  {/* </Tab>
                        <Tab eventKey="images" title="تصاویر" disabled={!values.id}>

                          <UploadImages {...props} />

                        </Tab>

                      </Tabs> */}

                  <div className="row">
                    <div className="col-md-12 col-xs-12">
                      <button
                        type="submit"
                        className={
                          'btn btn-success btn-block btn-ripple btn-font-lg' +
                          (isSubmitting ? 'isSubmitting' : '')
                        }
                        disabled={loading}
                        onClick={e => {
                          // setFieldValue('saveAndNew', true);
                          // e.preventDefault();
                          // this.setState({ saveAndNew: true }, () => {
                          //   handleSubmit();
                          // })

                          validateForm().then(errors => {
                            console.log(errors)
                            // console.log(JSON.stringify(values))
                            handleSubmit()
                          })
                        }}>
                        {this.props.match.params.id
                          ? 'ذخیره و بازگشت به لیست محصولات'
                          : 'ذخیره و ثبت محصول دیگر'}
                      </button>
                    </div>
                    {/* <div className="col-md-6 col-xs-6">
                      <button type="submit" className={"btn btn-info btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                        disabled={submittingAndNew || submittingAndGoBack || loading}
                        onClick={e => {
                          // setFieldValue('saveAndNew', false);
                          // e.preventDefault();
                          this.setState({ saveAndNew: false }, () => {
                            handleSubmit();
                          })

                          validateForm().then(errors => {
                            console.log(errors);
                            console.log(values);
                          })
                          // e.preventDefault();
                          // this.setState({ submitAndReturn: true }, () => {
                          //   // $(this).closest('form').submit()
                          //   handleSubmit();
                          // })
                        }}
                      >
                        {submittingAndGoBack ?
                          <AiOutlineLoading className="mdi-spin" size="22px" />
                          :
                          'ذخیره و بازگشت به لیست محصولات'
                        }
                      </button>
                    </div> */}
                  </div>
                </form>
              )
            }}
          </Formik>
        </div>
        {loading ? <Loading /> : ''}
      </div>
    )
  }
}

export default Form
